import React, { useState, useEffect, useContext, createContext } from "react";
import JSEncrypt from "jsencrypt";
import { LogContext } from "./LogContext";

export const JSEncryptContext = createContext();
export const JSEncryptProvider = ({ children }) => {
  const [encryptedString, setEncryptedString] = useState("");
  const { Log } = useContext(LogContext);

  const encryptText = (str) => {
    const encrypt = new JSEncrypt();
    const pubkey = process.env.REACT_APP_PUB_KEY;
    // Set the public key for encryption
    encrypt.setPublicKey(pubkey);

    let encrypted = "";
    try {
      // Attempt to encrypt the string
      encrypted = encrypt.encrypt(str);
      //setEncryptedString(encrypted);

      // Check if encryption was successful
      if (!encrypted) {
        throw new Error("Encryption failed. The string might be too large.");
      }
    } catch (e) {
      Log(
        "JS encryption",
        "CONSOLE",
        "",
        "Got exception: Encryption error: ".e.message,
        "ERROR",
        "",
        "",
        "",
        "F"
      );
    } finally {
      return encrypted;
    }
  };
  /* Toast */
  return (
    <JSEncryptContext.Provider value={{ encryptText }}>
      {children}
    </JSEncryptContext.Provider>
  );
};
